import React from 'react';
import cx from 'classnames';
const stripAtSign = str => str.replace('@', '');

class SingleDomainEmailInput extends React.Component {
  constructor() {
    super(...arguments);
    this.handleUserChange = this.handleUserChange.bind(this);
  }

  handleUserChange(e) {
    const user = stripAtSign(e.target.value);
    const domain = this.props.domains[0];
    this.props.onEmailChange(`${user}@${domain}`);
  }

  render() {
    const domain = this.props.domains[0];
    const user = this.props.email.split('@')[0];

    return (
      <div className="EmailInput">
        <div className="EmailInput__User">
          <input
            className={cx({
              EmailInput__Input: true,
              'EmailInput__Input--invalid': this.props.invalid,
            })}
            value={user}
            onChange={this.handleUserChange}
          />
        </div>
        <span className="EmailInput__AtSign">@</span>
        <div className="EmailInput__Domain">{domain}</div>
      </div>
    );
  }
}

export default SingleDomainEmailInput;
